import HttpClient from "../../../../core/HttpClient";
import { Authentication } from "@leedpulse-monorepo/classes";

export interface LiveStats {
    /**
     * Appels VoIP non terminés. La GSM en est absente : un appel GSM en cours
     * est indistinguable d'un document fantôme (LEED-1717), et le libellé
     * affiché doit le dire.
     */
    callsInProgress: number;
    /**
     * Lignes distinctes ayant eu un appel ou un SMS dans la fenêtre. Des
     * LIGNES, pas des utilisateurs : un doc `Calls` GSM ne porte aucun
     * identifiant d'utilisateur (miroir de `LiveStats`,
     * backend/src/helpers/leedflow/overview-model.ts).
     */
    activeLines: number;
    /** Largeur de la fenêtre, décidée par le backend et affichée telle quelle. */
    windowMinutes: number;
}

const EMPTY: LiveStats = { callsInProgress: 0, activeLines: 0, windowMinutes: 15 };

/** Fetches the Leedflow live counters (uncached route — see live.helpers.ts). */
async function getLiveStats(
    auth: Authentication | null,
    subscriptionIds?: string[],
    exclude?: string[],
): Promise<LiveStats> {
    if (!auth) return EMPTY;

    const body: { subscriptionIds?: string[]; exclude?: string[] } = {};
    if (subscriptionIds && subscriptionIds.length > 0) {
        body.subscriptionIds = subscriptionIds;
    }
    if (exclude && exclude.length > 0) {
        body.exclude = exclude;
    }

    const response = await HttpClient.post('/leedflow/live-stats', body, auth.token);

    // Même garde-fou que `getOverviewStats` : un backend antérieur à cette
    // route répond autre chose, et le bloc doit disparaître plutôt que rendre
    // « NaN en cours ».
    if (!response || typeof (response as LiveStats).callsInProgress !== 'number') {
        throw new Error('Réponse /leedflow/live-stats inattendue : backend non à jour ?');
    }

    return response as LiveStats;
}

export default getLiveStats;
